/**
 * LoadingScreen - ローディング画面コンポーネント
 */

export function LoadingScreen() {
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-white">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
        <p>読み込み中...</p>
      </div>
    </div>
  )
}